export default function validateDataViewer(ctx, storage) {
  const dataViewer = {}

  if (['table', 'cards'].includes(storage.viewType)) {
    dataViewer.viewType = storage.viewType
  }

  return dataViewer
}
